import dashboard from "./API/Dashboard"
import auth from "./API/Auth"
import tsic from "./API/Tsic"
import job from "./API/Jobs"
import data from "./API/Data"
import index from "./API/Indexes"
import statistics from "./API/Statistics"
import graphTypes from "./API/GraphTypes"
import preview from "./API/Preview"
import site from "./API/Site"
import banner from "./API/Banner"
import powerBi from "./API/PowerBi";
import dataDev from "./API/DataDeveloper";

export default {
  dashboard,
  auth,
  tsic,
  job,
  data,
  index,
  statistics,
  graphTypes,
  preview,
  site,
  banner,
  powerBi,
  dataDev,
}
